import { guid } from "zod/v4";

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_APP_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID,
};

export const firebaseProjectUrl = import.meta.env.VITE_APP_FIREBASE_PROJECT_URL;

// Only set locally, where the CMS (/docs) runs on a different origin than this app.
// Empty in cloud environments, where /docs is same-origin via a Hosting rewrite, so
// requests built with this stay relative.
export const docsOrigin = import.meta.env.VITE_APP_DOCS_ORIGIN || "";

// /api/print calls the CMS's Cloud Run service directly, bypassing the Hosting
// rewrite — Firebase Hosting has a hard, non-configurable 60s timeout on rewrites
// to Cloud Run, which large print documents can exceed. Falls back to docsOrigin
// (unset in cloud environments) so docsOrigin itself — used for the cookie-based
// /docs session flow — stays same-origin/Hosting-routed as before.
export const printOrigin = import.meta.env.VITE_APP_PRINT_ORIGIN || docsOrigin;

export const cognitoConfig = {
  userPoolId: import.meta.env.VITE_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: import.meta.env.VITE_APP_AWS_COGNITO_CLIENT_ID,
};

export const auth0Config = {
  clientId: import.meta.env.VITE_APP_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_APP_AUTH0_DOMAIN,
};

export const mapConfig = import.meta.env.VITE_APP_MAP_MAPBOX;

export const googleAnalyticsConfig = import.meta.env.VITE_APP_GA_MEASUREMENT_ID;

export const graphqlConfig = {
  https: import.meta.env.VITE_APP_GRAPHQL_HTTP,
  wss: import.meta.env.VITE_APP_GRAPHQL_WS,
};

export const defaultsConfig = {
  masterScheduleId: import.meta.env.VITE_APP_MASTER_SCHEDULE_ID,
  masterProjectId: import.meta.env.VITE_APP_MASTER_PROJECT_ID,
  procutTemplateManufacturerId: import.meta.env.VITE_APP_PRODUCT_TEMPLATE_MANUFACTURER_ID,
  productAttributesScheduleId: import.meta.env.VITE_APP_PRODUCT_ATTRIBUTES_SCHEDULE_ID,
  bossConsultancyid: import.meta.env.VITE_APP_BOSS_CONSULTANCY_ID,
  guestCompanyId: import.meta.env.VITE_APP_GUEST_COMPANY_ID,
  guidanceNotesId: import.meta.env.VITE_APP_GUIDANCE_NOTES_ID,
};
